import { render, staticRenderFns } from "./ReportQrCode.vue?vue&type=template&id=0bcd6f20&scoped=true"
import script from "./ReportQrCode.vue?vue&type=script&lang=js"
export * from "./ReportQrCode.vue?vue&type=script&lang=js"
import style0 from "./ReportQrCode.vue?vue&type=style&index=0&id=0bcd6f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd6f20",
  null
  
)

export default component.exports